import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';
import InfiniteScroll from 'react-infinite-scroller';

import { CONTEXT } from '../../../config/index';
import styles from './ForumListCollect.module.less';
import { logging, logPostInfo } from '../../../actions/log';
import InfinteScroll from '../../../components/InfinteScroll/GridInfinteScroll';
import ForumLine from '../../../components/Forum/ForumLine/ForumLine';
import Loading from '../../../components/Loading/Loading';
import ForumBar from '../ForumBar/ForumBar';
import ForumDefault from '../ForumDefault/ForumDefault';
import { getForumListCol } from '../../../actions/forum';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectForumList = createSelector(
  state => state.forum,
  forum => forum.forumListCol,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

function ForumListCollect() {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const forumList = useSelector(selectForumList);
  const userInfo = useSelector(selectUserInfo);
  const { dropScope } = useAliveController();

  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Forum_List_Collect`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Forum_List_Collect',
        label: '',
        param2: {
          source: 'Forum_List_Collect',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Forum_List_Collect',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  useEffect(() => {
    dispatch(getForumListCol({ refresh: true }));
  }, [userInfo]);

  const loadMore = useCallback(() => {
    dispatch(getForumListCol({ refresh: false }));
  }, []);

  useEffect(() => {
    // 用户退出登录删除页面缓存
    if (!userInfo.st) {
      dropScope('forumlistpublish');
    }
  }, [userInfo]);

  useEffect(() => {
    // 接口请求失败
    if (userInfo.st && forumList && forumList.refresh === true && forumList.loading === -1) {
      history.replace(`${CONTEXT}/error?sourcePage=Forum`);
    }
  }, [forumList, userInfo]);

  const login_status = window.CallNativeMethod('get_login_status');
  if (
    login_status === '1' &&
    userInfo.st &&
    (!forumList || !forumList || !forumList.forumContentList)
  ) {
    return (
      <div className={styles.loading}>
        <ForumBar />
        <Loading />
      </div>
    );
  }
  if (
    !forumList ||
    !forumList.forumContentList ||
    forumList.forumContentList.length === 0 ||
    login_status !== '1' ||
    !userInfo.st
  ) {
    return (
      <div className={styles.loading}>
        <ForumBar />
        <ForumDefault />
      </div>
    );
  }
  return (
    forumList &&
    forumList &&
    forumList.forumContentList &&
    forumList.forumContentList.length > 0 && (
      <div className={styles.forum}>
        <ForumBar />
        <InfiniteScroll
          className={styles.forum_list}
          pageStart={1}
          loadMore={loadMore}
          hasMore={forumList.forumContentList.length < forumList.count}
          loader={
            <div className="loader" key={0}>
              ----------加载中----------
            </div>
          }
          initialLoad={false}
          useWindow={false}
          getScrollParent={() => document.getElementById('forum_list_pub')}
        >
          {forumList.forumContentList.map((item, index) => {
            return (
              <ForumLine forumData={item} key={index} logInfo={{ source: 'Forum_List_Publish' }} />
            );
          })}
        </InfiniteScroll>
      </div>
    )
  );
}
export default () => (
  <KeepAlive name="forumlistcollect">
    <ForumListCollect></ForumListCollect>
  </KeepAlive>
);
